import colors from "core/colors";

export const palette = [
    colors.black,
    "#676767",
    "#9B9B9B",
    "#D3D3D3",
    "#FFFFFF",
    "#FF001C",
    "#FF59B9",
    "#C462DD",
    "#4C25E1",
    "#00449F",
    "#FF824A",
    "#FFB258",
    "#FFD65B",
    "#C3DC64",
    "#71D358",
    "#007435",
    "#00BBC3",
    "#45DEE1",
    "#12B0FB",
    "#3B6BF9"
];
